<template>
  <div class="main">
    <p>
      考核云培训任务，支持将系统中考试、练习、视频、课件进行任意组合，搭建培训流程;基于海量题库，支持个性化流程定制，任务学习满足要求后自动获取学分单个任务数据与整体培训情况全程清晰可见，组织信息支持数据按导出，便于存档。
    </p>
    <div class="diagram_view">
      <el-image style="height: 460px" :src="url" :preview-src-list="srcList">
      </el-image>
      <el-image style="height: 460px" :src="urlTwo" :preview-src-list="srcList">
      </el-image>
    </div>
    <div class="button_view">
      <el-button type="primary" @click="customerInfo = true"
        >联系客服试用</el-button
      >
      <!-- <el-button type="primary" @click="qrdialogVisible = true"
        >扫码体验考核打分</el-button
      > -->
    </div>
    <!-- 联系客服弹窗 -->
    <div class="modify">
      <el-dialog
        title="温馨提示"
        :visible.sync="customerInfo"
        :close-on-click-modal="false"
        width="25vw"
      >
        <div class="mian">
          <div class="flex">
            <p>QQ：1926197022</p>
            <p>电话：13877286037 罗经理</p>
          </div>
          <div class="flex">
            <p>QQ：3971609</p>
            <p>电话：13978105008（微信同号） 黄经理</p>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="customerInfo = false">取 消</el-button>
          <el-button type="primary" @click="customerInfo = false"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      url: require("@/assets/images/px_pc1.png"),
      urlTwo: require("@/assets/images/px_pc2.png"),
      srcList: [
        require("@/assets/images/px_pc1.png"),
        require("@/assets/images/px_pc2.png"),
      ],
      customerInfo: false, // 客服信息弹窗

    };
  },
};
</script>

<style lang="scss" scoped>
.main {
  box-sizing: border-box;
  background-color: #ffffff;
  width: 100%;
  //   height: 100%;
  min-height: 780px;
  padding: 36px;
  // display: flex;
  // justify-content: center;
  // align-items: center;
  > p {
    text-indent: 24px;
    font-size: 16px;
  }
  .diagram_view {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 50px;
    .el-image {
      //   height: 360px;
      border: 3px solid #9195A0;
      &:nth-child(1) {
        margin-right: 100px;
      }
    }
  }
  .button_view {
    margin-top: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    .el-button {
      background: #0084ea;
      &:nth-child(1) {
        margin-right: 140px;
      }
    }
  }
}
.modify {
  ::v-deep .el-dialog__headerbtn .el-dialog__close {
  font-size: 24px;
  color: #fff;
}
::v-deep .el-dialog__header {
  height: 55px;
  background: #0084ea;
  opacity: 1;
  border-radius: 5px 5px 0px 0px;
  font-size: 16px;
  letter-spacing: 2px;
  font-family: PingFang SC;
  box-sizing: border-box;
  text-align: center;
  .el-dialog__title {
    color: #fff;
  }
}
::v-deep .el-dialog__wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
::v-deep .el-dialog__footer {
  padding: 0;
  text-align: center;
  display: flex;
  justify-content: center;
  align-content: center;
  button {
    width: 80px;
    height: 40px;
    border-radius: 2px;
    color: #fff;
    font-size: 14px;
    &:nth-child(1) {
      background: #c4c4c4;
      margin-right: 10px;
    }
    &:nth-child(2) {
      background: #0084ea;
    }
  }
}
  .title_box {
    // height: 54px;
    padding-bottom: 9px;
    margin-bottom: 20px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 19px;
    color: #333333;
    border-bottom: 1px solid #abd7ff;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }
  ::v-deep .dialog-footer {
    margin-bottom: 30px;
    width: 100% !important;
  }
  ::v-deep.el-dialog__footer {
    justify-content: left !important;
  }
  span > button:nth-child(3) {
    margin-left: 50px;
  }
  ::v-deep .el-dialog__footer span > button:nth-child(2) {
    margin-left: 0;
  }
  .mian {
    display: flex;
    flex-direction: column;
    align-items: center;
    .flex{
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 12px;
      p{
        &:nth-child(1){
          margin-right: 12px;
        }
      }
    }
    p {
      //   width: 120px;
      line-height: 24px;
    }
    ::v-deep .el-input__inner {
      width: 280px;
    }
  }
  .el-dialog__footer span > button {
    margin-top: 10px;
  }
  ::v-deep .el-dialog {
    width: 400px;
    border-radius: 5px 5px 0px 0px;
    .input_layout {
      display: flex;
      > .el-form-item {
        flex: 1;
        display: flex;
        align-content: center;
        ::v-deep .el-input {
          width: 420px;
        }
      }
    }
  }
}
</style>
